document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[data-tab]').forEach(function(tabContainer) {
    // Знаходимо всі заголовки вкладок всередині поточного data-tab
    var tabTitles = tabContainer.querySelectorAll('[data-tab-title]');
    tabTitles.forEach(function(tabTitle) {
      tabTitle.addEventListener('click', function() {
        // Видаляємо клас 'active' з усіх елементів data-tab-item всередині поточного data-tab
        var tabItems = tabContainer.querySelectorAll('[data-tab-item]');
        tabItems.forEach(function(tabItem) {
          if (tabItem.dataset.tabToggle) {
            tabItem.children[0] === tabTitle
              ? tabItem.classList.contains('active')
                ? tabItem.classList.remove('active')
                : tabItem.classList.add('active')
              : tabItem.classList.remove('active')
            return;
          }
          tabItem.classList.remove('active');
        });
        // Додаємо клас 'active' до батьківського елемента data-tab-item
        var tabItem = tabTitle.closest('[data-tab-item]');
        if (tabItem && !tabItem.dataset.tabToggle) {
          tabItem.classList.add('active');
        }
      });
    });
  });
});
